import Vue from 'vue';

const files = require.context('@/layouts/.', false, /\.vue$/);
files.keys().forEach((fileName: string) => {
  if (fileName !== undefined) {
    const splittedName = fileName.split('/');
    if (splittedName !== undefined) {
      const poppedName = splittedName.pop();
      if (poppedName !== undefined) {
        const name = poppedName.split('.');
        const componentName = `layout-${name[0]}`;
        Vue.component(componentName, files(fileName).default);
      }
    }
  }
});
